import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { themeClasses } from '../../config/themeClasses';
import { cn } from '../../lib/utils';

export default function LandingShowcaseSection({
  eyebrowKey,
  titleKey,
  subtitleKey,
  children,
  reverse = false,
  className,
  background = 'default',
}) {
  const { t } = useLocale();

  const bgClass =
    background === 'secondary'
      ? 'border-y border-border-light bg-background-secondary'
      : '';

  return (
    <section className={cn(themeClasses.landing.section, bgClass, className)}>
      <div className={themeClasses.landing.containerWide}>
        <div className="mx-auto max-w-2xl text-center">
          {eyebrowKey ? (
            <p className={themeClasses.landing.eyebrow}>{t(eyebrowKey)}</p>
          ) : null}
          <h2 className={cn('text-display-lg', eyebrowKey && 'mt-3')}>{t(titleKey)}</h2>
          {subtitleKey ? (
            <p className="text-body-lg mt-4">{t(subtitleKey)}</p>
          ) : null}
        </div>
        <div className={cn('mt-12', reverse && 'lg:[direction:rtl] lg:[&>*]:[direction:ltr]')}>
          {children}
        </div>
      </div>
    </section>
  );
}
